/* eslint-disable import/prefer-default-export */
export async function Fetch(url, params) {
  function loginIdp() {
    const { origin, pathname, search } = window.location;
    const href = `${origin}/idp-auth/redirect?redirect-uri=${pathname}${search}`;

    window.location.href = href;
  }

  let fetchParams = params;
  if (!fetchParams) {
    fetchParams = { headers: {} };
  }
  let res;
  fetchParams = {
    ...fetchParams,
    headers: {
      ...fetchParams.headers,
      "idp-api": true,
    },
  };

  try {
    res = await fetch(url, fetchParams);
  } catch (e) {
    res = new Response();
  }

  // has 'errorsystem' in header means internal 401 and shouldn't redirect
  if (res.status === 401 && !res.headers.has("errorsystem")) {
    loginIdp();
  }

  return res;
}
